import { useAppSelector } from "../../../../../../redux/hooks";
import Button from "../../../../button/button.index";
import { ButtonType } from "../../../../button/button.interface";
import Dialog from "../../../../dialog/dialog.index";
import { DialogSize } from "../../../../dialog/dialog.interface";
import { handleClearAllSelectedResources, handleDownloadTheResource, handleSetCollaboraModalStatus } from "../../../fileManager.actions";
import { ReactComponent as UnsuccessfulIcon } from "../../../../../../assets/images/svg/unsuccessful-payment-primary.svg";
import { useNavigate } from "react-router-dom";
import PATH from "../../../../../../urls/path";

const CollaboraCheckModal = () => {
    const navigate = useNavigate();

    const { collaboraModalStatus } = useAppSelector(({ fileManager: { collaboraModalStatus } }) => ({ collaboraModalStatus }));

    return (
        <Dialog
            closeButton={false}
            size={DialogSize.MD}
            className="p-6 md:!max-w-[480px] !rounded-[10px]"
            status={collaboraModalStatus}
            onClose={() => {
                handleSetCollaboraModalStatus(false);
                handleClearAllSelectedResources();
            }}
        >
            <div>
                <div className="mb-4 md:mb-5 flex items-center justify-center">
                    <UnsuccessfulIcon className="w-[150px] h-[72px]" />
                </div>
                <p className="mb-6 md:mb-8 text-base text-center font-medium text-secondary-700 leading-8">
                    به دلیل استفاده از اشتراک رایگان، متأسفانه، شما امکان نمایش فایل های آفیس را ندارید. اما میتوانید با خرید اشتراک از این امکان
                    استفاده کنید
                </p>
                <div className="flex items-center flex-col-reverse md:flex-row gap-4 md:gap-5">
                    <div className="flex flex-row-reverse md:flex-row items-center gap-4 md:gap-5 w-full md:flex-1">
                        <Button
                            text="انصراف"
                            type={ButtonType.CANCEL}
                            onClick={() => handleSetCollaboraModalStatus(false)}
                            className="flex-1 whitespace-nowrap md:w-[90px] font-medium text-[15px] h-10 !border-[1.5px]"
                        />
                        <Button
                            text="دانلود فایل"
                            type={ButtonType.SECONDARY}
                            onClick={() => {
                                handleDownloadTheResource();
                                handleSetCollaboraModalStatus(false);
                            }}
                            className="flex-1 md:w-[124px] whitespace-nowrap font-medium text-[15px] h-10 !border-[1.5px]"
                        />
                    </div>

                    <Button
                        text="خرید بسته"
                        type={ButtonType.PRIMARY}
                        className="md:flex-1 whitespace-nowrap font-medium w-full md:w-auto text-[15px] h-10 !border-[1.5px]"
                        onClick={() => {
                            navigate(PATH.planRecommendation);
                            handleSetCollaboraModalStatus(false);
                        }}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default CollaboraCheckModal;
